import _createClass from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { Exception } from "../../core";
/**
 * An exception indicating an unsupported content type prevented execution.
 * @public
 */
export var ContentTypeUnsupportedError = /*#__PURE__*/function (_Exception) {
  _inherits(ContentTypeUnsupportedError, _Exception);
  var _super = _createSuper(ContentTypeUnsupportedError);
  function ContentTypeUnsupportedError(message) {
    _classCallCheck(this, ContentTypeUnsupportedError);
    return _super.call(this, message ? message : "Unsupported content type.");
  }
  return _createClass(ContentTypeUnsupportedError);
}(Exception);